import {plural} from '../../common/components/Plural.js'
import ListItemsCount from '../../common/components/List/ListItemsCount.js'
import {moListQuerySelector, countSelector} from './moListSelectors.js'
import {useSelector} from '../../store.js'

export default function MOListItemsCount() {
  const params = useSelector(moListQuerySelector)
  const count = useSelector(countSelector)

  return (
    <li className="inline-block margin-right-3">
      <ListItemsCount
        limit={params.limit}
        offset={params.offset}
        count={count}
        thing={plural(count)`MFG Order${['s']}`}
      />
    </li>
  )
}
